<template>
  <div class="allTenantBg">
    <div class="allTenant_title">
      资产列表
    </div>
    <div class="tenant_box clearfix_">
      <div class="fl tenant_item" v-for="(item,index) in tenantList" :key="index">
        <div class="tenant_item_t clearfix_">
          <div class="fl tenant_item_t_img"><img :src="item.webPic?item.webPic:timg" alt=""></div>
          <div class="fl tenant_item_t_txt">
            <p :title="item.tenantName">{{item.tenantName}}</p>
            <p :title="'等级：'+item.levelName" style="margin-bottom:7px;">等级：{{item.levelName}}</p>
            <p :title="'升级差额：'+item.price">升级差额：{{item.price}}</p>
          </div>
        </div>
        <div class="tenant_item_b">
          <div class="tenant_item_b_txt1">余额：<span>{{item.moneyAmount}}</span></div>
          <div class="clearfix_ tenant_item_b_txt2">
            <p class="fl">积分：<span>{{item.score}}</span></p>
            <p class="fl">储值：<span>{{item.cardRuleNum}}</span></p>
            <p class="fl">优惠券：<span>{{item.couponNum}}</span></p>
            <p class="fl">礼包：<span>{{item.shoppingNum}}</span></p>
          </div>
        </div>
      </div>
    </div>
    
    <!-- <div v-for="(item,index) in tenantList" :key="index" class="myAssets_details clearfix_">
      <div class="myAssets_details_logo fl">
        <img :src="item.webPic?item.webPic:timg" alt="">
      </div>
      <div style="width:785px;" class="fl clearfix_">
        <div @click="goToMemberBalance(item.memberCardId,item.tenantId)" class="fl myAssets_details_txt">
          余额：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{item.moneyAmount}}</span>
        </div>
        <div @click="goToMemberScore(item.memberCardId,item.tenantId)" class="fl myAssets_details_txt">
          积分：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{item.score}}</span>
        </div>
        <div @click="goToStoredValueCard(item.memberCardId,item.tenantId)" class="fl myAssets_details_txt">
          储值：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{item.cardRuleNum}}</span>
        </div>
        <div class="fl myAssets_details_txt">
          优惠券：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{item.couponNum}}</span>
        </div>
        <div class="fl myAssets_details_txt">
          礼包：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{item.shoppingNum}}</span>
        </div>
      </div>
    </div> -->
    <div class="all_tenant_pages">
      <div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage3"
          :page-size="18"
          layout="prev, pager, next, jumper"
          :total="this.total">
        </el-pagination>
      </div> 
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return {
      tenantList:[],
      timg:require('../../assets/img/chuniu_.png'),
      currentPage3:1,
      total:0
    }
  },
  mounted:function(){
    this.getTenant(this.currentPage3)
  },
  methods:{
    handleSizeChange(val){

    },
    handleCurrentChange(val) {
      this.currentPage3=val
      this.tenantList=[]
      this.getTenant(val)
    },
    goToStoredValueCard:function(memberCardId,tenantId){
      var t_=this
			var href=this.$router.resolve({name:'storedValueCard',query:{memberCardId:memberCardId,tenantId:tenantId}})
      return window.open(href.href,'_blank')
    },
    goToMemberScore:function(memberCardId,tenantId){
      var t_=this
			var href=this.$router.resolve({name:'memberScore',query:{memberCardId:memberCardId,tenantId:tenantId}})
      return window.open(href.href,'_blank')
    },
    goToMemberBalance:function(memberCardId,tenantId){
      var t_=this
			var href=this.$router.resolve({name:'memberBalance',query:{memberCardId:memberCardId,tenantId:tenantId}})
      return window.open(href.href,'_blank')
    },
    getTenant:function(page){
      var t_=this
      var data0bj=Qs.stringify({
        page:page,
        pagesize:10,
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:''
      })
      axios.post(`${ip}formWorkInterface/getUserMemberCard`,data0bj).then(res =>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code!=0)return
        t_.tenantList=res.data.data.rows
        t_.total=res.data.data.total
      })
    },
  }
}
</script>
<style>
  .allTenantBg{
    width: 1028px;
    border: 1px solid #ddd;
    background: #fff;
  }
  .allTenant_title{
    height: 38px;
    line-height: 38px;
    font-size:16px;
    font-weight: 900;
    background: #fafafa;
    padding-left: 10px;
  }
  .myAssets_details{
    padding: 20px;
  }
  .myAssets_details_logo{
    width: 200px;
    height: 40px;
    overflow: hidden;
    text-align: center;
  }
  .myAssets_details_logo img{
    height: 40px;
  }
  .myAssets_details span{
    color:#f70;
  }
  .allTenantBg .myAssets_details_txt{
    line-height: 40px;
    width: 20%;
    cursor: pointer;
  }
  .tenant_box{
    padding: 16px;
  }
  .tenant_item{
    width: 318px;
    height: 171px;
    border: 1px solid #efefef;
    padding-top: 7px;
    margin: 0 16px 15px 0;
  }
  .tenant_item:nth-child(3n){
    margin-right: 0;
  }
  .tenant_item_t{
    margin-left: 11px;
    margin-bottom: 24px;
  }
  .tenant_item_t_img{
    width: 70px;
    height: 70px;
    border: 1px solid #ccc;
    overflow: hidden;
    border-radius: 50%;
    margin-right: 18px;
    display:flex;
    justify-content:center;
    align-items:center;
  }
  .tenant_item_t_img img{
    width: 70px;
  }
  .tenant_item_t_txt{
    margin-top: 12px;
  }
  .tenant_item_t_txt p:first-child{
    font-size:14px;
    color:#666;
    margin-bottom: 10px;
  }
  .tenant_item_t_txt p:last-child{
    font-size:14px;
    color:#666;
  }
  .tenant_item_b{
    margin-left:28px;
  }
  .tenant_item_b span{
    color:#f00;
  }
  .tenant_item_b_txt1{
    font-size:12px;
    color:#666;
    margin-bottom: 13px;
  }
  .tenant_item_b_txt2 p{
    width: 50%;
    margin-bottom: 13px;
  }
  .all_tenant_pages{
    text-align: center;
    margin: 15px 0;
  }
  .all_tenant_pages .el-pagination__jump{
    margin-top:-9px;
  }
  .all_tenant_pages .el-pagination__editor{
    top:9px;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/allTenant.vue